import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import News from '../blocks/News';
import Company from '../blocks/Company';
import Products from '../blocks/Products';
import Documentation from '../blocks/Documentation';
import Contract from '../blocks/Contract';
import Career from '../blocks/Career';
import Contacts from '../blocks/Contacts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import mainImg from '../img/mainImg.png';
import Search from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Markdown from 'react-markdown';
import { fetchMainPage, searchArticles } from '../strapi';
import CircularProgress from '@mui/material/CircularProgress';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import line from '../img/line.png';
import { Link } from 'react-router-dom';

function Main({ setNewsId, setProductId, locale, main, info, current, setCurrent }) {
    // Scroll to Top Button
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Add this at the end of your component's return (outside/after other JSX if needed):

    let searchPlaceholder = locale == 'ru' ? 'Поиск' : 'Search';
    let loading = locale == 'ru' ? 'Загрузка...' : 'Loading...';
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [searching, setSearching] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10); // Number of results per page
    const [total, setTotal] = useState(0);
    const [anchorElSaved, setAnchorElSaved] = useState(null);
    const navigate = useNavigate();



    const handleSearch = async (event, pageArg = 1) => {

        const q = (query || '').trim();
        if (!q) {
            setResults([]);
            setAnchorEl(null);
            setTotal(0);
            return;
        }
        setSearching(true);
        setAnchorEl(event?.currentTarget || anchorEl);


        try {
            // Assuming your searchArticles supports pagination
            const data = await searchArticles(q, locale, pageArg, pageSize);
            // If your API returns meta.pagination, use it for total count
            const items = data.data.data;
            setResults(items);
            //console.log("total: ", data.meta?.pagination?.total);
            setTotal(data.meta?.pagination?.total || items.length);
        } catch (err) {
            console.error('Search error', err);
            setResults([]);
            setTotal(0);
        } finally {
            setSearching(false);
        }
    };

    const handlePageChange = async (event, value) => {
        setPage(value);
        await handleSearch(anchorElSaved, value);
        // setAnchorEl(event.currentTarget)
    };

    // Reset page to 1 on new query
    useEffect(() => {
        setPage(1);
    }, [query]);


    const handleResultClick = (item) => {
        setAnchorEl(null);

        if (item.documentId) {
            let to = '';
            if (item.resource === 'products' || item.resource === 'news') {
                setCurrent(`/${item.resource}`)
                to = `/${item.resource}/${item.documentId}`;
            }
            else if (item.resource === 'main-pages') {
                setQuery('');
                setSearching(false);
                setResults([]);
                setCurrent('/')
                to = `/`;
            }
            else {
                setCurrent(`/${item.resource}`)
                to = `/${item.resource}`;
            }

            // Instead of navigate, you can render a Link or programmatically change location
            // Here, for demonstration, we set window.location (since handleResultClick is not a render function)
            window.location.href = to;
        }
    };
     const closeSearch = () => {
        setAnchorEl(null);
        setQuery('');
        setSearching(false);
        setResults([]);
    };

useEffect(() => {
            if (window.location.hash) {
                console.log(window.location.hash)
                const link = document.createElement("a");
                link.href = window.location.hash;
                document.body.appendChild(link);
                setTimeout(() => {
                    link.click();
                }, 500);
                
                document.body.removeChild(link);
            }
            

    //     if (current !== '/') {
    //     console.log(window.location.hash)
    //     console.log(current)
    //     const link = document.createElement("a");
    //     link.href = current;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // }
    
}, [])


    // useEffect(() => {
    //     // Check if there's a hash in the URL (e.g., /#section-id)
    //     if (window.location.hash) {
    //         const id = window.location.hash.substring(1);
    //         // Try to scroll to the element with that id
    //         setTimeout(() => {
    //             const el = document.getElementById(id);
    //             if (el) {
    //                 // Determine offset based on device width (adaptive for mobile)
    //                 let offset = 200;
    //                 if (window.innerWidth <= 600) {
    //                     // Smaller offset for mobile devices
    //                     offset = 80;
    //                 }
    //                 const rect = el.getBoundingClientRect();
    //                 const scrollTop = window.pageYOffset - offset || document.documentElement.scrollTop;
    //                 window.scrollTo({
    //                     top: rect.top + scrollTop,
    //                     behavior: 'smooth'
    //                 });
    //             }
    //         }, 0);
    //     }
    // }, [window.location.hash]);

    // Scroll to hash element on mount and when hash changes (e.g., after navigation)
    // const scrollToHash = () => {
    //     if (window.location.hash) {
    //         // setCurrent(window.location.hash);
    //         const id = window.location.hash.substring(1);
    //         setTimeout(() => {
    //             const el = document.getElementById(id);
    //             if (el) {
    //                 // Determine offset based on device width (adaptive for mobile)
    //                 let offset = 400;
    //                 if (window.innerWidth <= 600) {
    //                     // Smaller offset for mobile devices
    //                     offset = 80;
    //                 }
    //                 const rect = el.getBoundingClientRect();
    //                 const scrollTop = window.pageYOffset + offset || document.documentElement.scrollTop;
    //                 window.scrollTo({
    //                     top: rect.top + scrollTop,
    //                     behavior: 'smooth'
    //                 });
    //             }
    //         }, 0);
    //     }
    // };


    // useEffect(() => {
    //     // On mount
    //     scrollToHash();

    //     // On hash change
    //     const onHashChange = () => {
    //         scrollToHash();
    //     };
    //     window.addEventListener('hashchange', onHashChange);

    //     return () => {
    //         window.removeEventListener('hashchange', onHashChange);
    //     };
    // }, []);

    // useEffect(() => {
    //     const sections = document.querySelectorAll('div[id]');
    //     const observer = new IntersectionObserver(
    //         (entries) => {
    //             entries.forEach((entry) => {
    //                 if (entry.isIntersecting) {
    //                     if (entry.target.id === 'documentation') {
    //                         setCurrent(`/catalog`);
    //                     } else {
    //                         if (entry.target.id === 'news' || entry.target.id === 'root'){
    //                             setCurrent(`/`);
    //                         }
    //                     else {
    //                         setCurrent(`/#${entry.target.id}`);
    //                     }}                     
    //                 }
    //             });
    //         },
    //         {
    //             root: null,
    //             rootMargin: '-50% 0px -50% 0px',
    //             threshold: 0,
    //         }
    //     );

    //     sections.forEach((section) => {
    //         observer.observe(section);
    //     });

    //     return () => {
    //         sections.forEach((section) => {
    //             observer.unobserve(section);
    //         });
    //     };
    // }, [setCurrent]);


    return (
        <div >
            {main == null &&
                <div className='back'>
                    <div className='loading'>
                        <Typography className='titleOfParagraph loadingTitle'>{loading}</Typography>
                        <CircularProgress className='loadingImg'></CircularProgress>
                    </div>
                </div>}
            {main != null &&
                <>
                
                    <Box sx={{ bgcolor: '#E1EEFF',  pb: {xs:'200px', sm: '400px', md: '200px'},   position: 'relative', top: '0'}}>
                        
                        <Container id='top'>
                            
                            <Grid container sx={{ pt: { xs: '70px', md: '100px' } }}>
                                <Grid size={{ xs: 12, md: 6, xl: 8 }}>
                                    <Typography gutterBottom sx={{ fontWeight: 'bold', color: '#2D5B96', fontSize: { xs: '42px', sm: '50px', md: '50px', lg: '60px' } }} component="div">
                                        {main[0]?.title || <Skeleton />}
                                    </Typography>
                                    <img alt='line' src={line} width='300px' style={{ display: 'block', marginBottom: '30px', marginTop: '-20px' }} />
                                    <Box
                                        sx={{
                                            p: 2,
                                            maxWidth: '520px',
                                            position: 'relative',
                                            mb: 2,
                                            mt: 1,
                                            bgcolor: {xs: 'rgb(225, 238, 255, 0.3)', md: 'transparent'},
                                            backdropFilter: 'blur(10px)',
                                            WebkitBackdropFilter: 'blur(10px)',
                                            borderRadius: '10px',
                                            zIndex: '8',
                                        }}
                                    >
                                        <Typography
                                            component='div'
                                            variant="body1"
                                            sx={{
                                               
                                                fontSize: { xs: '16px', lg: '16px' },
                                                color: 'text.secondary',
                                                maxWidth: '500px',
                                                zIndex: '8',
                                                position: 'relative',
                                                
                                            }}
                                        >
                                            {main[0]?.text || <Skeleton />}
                                        </Typography>
                                    </Box>
                                   
                                    <Box sx={{ width: '100%', display: 'flex', justifyContent: {xs: 'center', md: 'flex-end'}, zIndex: 8, position: 'relative', ml: {xs: '0', ld: '-80px'}, mt: { sm: '10px', md: '0px', lg: '10px' } }}>
                                        <Box sx={{
                                            bgcolor: 'rgba(255,255,255,0.85)',
                                            backdropFilter: 'blur(5px)',
                                            WebkitBackdropFilter: 'blur(5px)',
                                            width: { xs: '250px', md: '400px' },
                                            borderRadius: '50px',
                                            p: { xs: 1, md: 1.5 },
                                            m: { xs: 0.5, md: 3},
                                            boxShadow: '0 4px 24px 0 rgba(0,0,0,0.04)'
                                        }} className='searchBox'>
                                            <Stack direction="row" sx={{ width: '100%', display: 'flex', alignItems: 'center' }} className='search'>
                                                
                                                <input
                                                    className='my_input'
                                                    value={query}
                                                    placeholder={searchPlaceholder}
                                                    onChange={e => setQuery(e.target.value)}
                                                    onKeyDown={e => { if (e.key === 'Enter') handleSearch(e); setAnchorElSaved(e) }}
                                                    style={{ width: '100%', border: 'none', outline: 'none', background: 'transparent', fontSize: "24px" }}
                                                />
                                                    <Search
                                                        onClick={(e) => { handleSearch(e); setAnchorElSaved(e) }}
                                                     sx={{bgcolor: '#2D5B96', borderRadius: '50px', alignItems: 'center', justifyContent: 'center', p: 1, cursor: 'pointer', color: '#ffffff', fontSize: { xs: "20px", md: "30px" }}} />
                                            </Stack>

                                            <Menu
                                                anchorEl={anchorEl}
                                                open={(anchorEl) && (searching || results.length > 0 || (query && results.length === 0))}
                                                onClose={() => closeSearch()}
                                            >
                                                {searching && (
                                                    <MenuItem disabled>
                                                        <Typography variant="body2">{loading}</Typography>
                                                    </MenuItem>
                                                )}
                                                {!searching && results?.length > 0 && results.map((item, idx) => (
                                                    <MenuItem
                                                        key={idx}
                                                        onClick={() => handleResultClick(item)}
                                                        sx={{ alignItems: 'flex-start', whiteSpace: 'normal' }}
                                                    >
                                                        <Box>
                                                            <Typography variant="subtitle2">
                                                                {item.attributes?.title || item.title || '-'}
                                                            </Typography>
                                                            <Typography variant="body2" color="text.secondary">
                                                                {(() => {
                                                                    const context = item.attributes?.context || item.context || '';
                                                                    const queryLower = query.toLowerCase();
                                                                    const contextLower = context.toLowerCase();
                                                                    const idxFound = contextLower.indexOf(queryLower);
                                                                    if (idxFound === -1 || !query) return context;
                                                                    return (
                                                                        <>
                                                                            {context.slice(0, idxFound)}
                                                                            <b>{context.slice(idxFound, idxFound + query.length)}</b>
                                                                            {context.slice(idxFound + query.length)}
                                                                        </>
                                                                    );
                                                                })()}
                                                            </Typography>
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                                {!searching && results?.length === 0 && query && (
                                                    <MenuItem disabled>
                                                        <Typography variant="body2">{locale === 'ru' ? 'Ничего не найдено' : 'No results'}</Typography>
                                                    </MenuItem>
                                                )}
                                                {/* Paging controls */}
                                                {!searching && total > pageSize && (
                                                    <MenuItem disableRipple sx={{ justifyContent: 'center' }}>
                                                        <Pagination
                                                            className='pagination'
                                                            sx={{ color: "#5281B5", justifyContent: 'center' }}
                                                            color="primary"
                                                            count={Math.ceil(total / pageSize)}
                                                            page={page}
                                                            onChange={handlePageChange}
                                                            size="small"
                                                        />
                                                    </MenuItem>
                                                )}
                                            </Menu>
                                        </Box>
                                    </Box>
                                </Grid>
                                {/* {window.innerWidth >=  1024 && (<>
                                    <Grid size={{ xs: 12, md: 6, xl: 4 }} >
                                        
                                        
                                        </Grid>
                                    
                                </>
                                    
                                )} */}
                            </Grid>
                            
                        </Container>
                        </Box>
                       
                       {/* {window.innerWidth < 1024 && (
                                    <Grid size={{ xs: 12, md: 6, xl: 4 }} >
                                        
                                        <Box  sx={{minHeight: '700px'}}>
                                            <img alt='main' style={{ zIndex: 5 }} src={mainImg} className='mainTrain'></img>
                                        </Box>
                                    </Grid>
                                )} */}
                        {/* <Box className='boxOfProducts' sx={{ bgcolor: '#2D5B96',top: '700px', position: 'absolute',  width: '100%', minHeight: '200px' }} >
                            <Container>
                                <Grid container sx={{ p: 3 }}>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography gutterBottom variant="h5" component="div" color='white'>
                                            {main[1]?.title}
                                        </Typography>
                                        {<Typography color='white' variant="body1" component='div'> <Markdown >{main[1]?.text || ''}</Markdown></Typography>}

                                    </Grid>
                                </Grid>
                            </Container>
                        </Box> */}
                        <div className='dot'></div>
                            {/* <Box height="700px" ></Box> */}
                            <img alt='main' style={{ zIndex: 7 }} src={mainImg} className='mainTrain'></img>
                            <Box className='boxOfProducts' sx={{ bgcolor: '#2D5B96', position: 'relative', pt: {xs: '90px', md: '120px', lg: '0'}, top: {xs: '-900px', sm: '-1100px',  md: '-1400px'},  width: '100%', minHeight: '200px', mb:{xs: '-900px', md: '-1300px'} }}>
                            <Container>
                                <Grid container sx={{ p: 3 }}>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography gutterBottom variant="h5" component="div" color='white'>
                                            {main[1]?.title}
                                        </Typography>
                                        {<Typography color='white' variant="body1" component='div'> <Markdown >{main[1]?.text || ''}</Markdown></Typography>}

                                    </Grid>
                                </Grid>
                            </Container>
                            </Box>
                    
                    <div className='scrollContainer'  id='news'>
                        <News content={main[2]} setNewsId={setNewsId} locale={locale}   />
                    </div>
                    <div className='scrollContainer'  id='company'>
                        <Company content={main[3]} content_={main[4]} locale={locale} />
                    </div>
                    <div className='scrollContainer' id='products'> 
                        <Products content={main[5]} locale={locale} contentD={main[6]}/>
                    </div>
                    {/* <div className='scrollContainer' id='documentation'> 
                        <Documentation content={main[6]} locale={locale} />
                    </div> */}
                    <div className='scrollContainer'  id='contract' >
                        <Contract content={main[7]} locale={locale} />
                    </div>
                    <div className='scrollContainer'  id='career' >
                        <Career content={main[8]} locale={locale} />
                    </div>
                    <div className='scrollContainer'  id='contacts' > 
                        <Contacts content={main[9]} locale={locale} info={info} />
                    </div>
                </>}
         <Button
   onClick={handleScrollToTop}
    variant="contained"
        color="white !important"
        sx={{
            position: 'fixed',
            bottom: 32,
            right: 32,
            zIndex: 2000,
            minWidth: 0,
            width: 48,
            height: 48,
            borderRadius: '50%',
            display: showScroll ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 3,
            bgcolor: '#2D5B96',
            color: '#fff !important',
           '&:hover': { bgcolor: '#5281B5' }
     }}
    >
       <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
           <path d="M12 19V5M12 5l-7 7M12 5l7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </Button>
        </div >
    );
}

export default Main;
